import {store} from './stores'
import i18n, {languages} from './plugins/i18n'
window._ = require('lodash')


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
window.axios.defaults.withCredentials = true

window.axios.interceptors.request.use(config => {
  store.commit('interception/clear')

  const currentLang = languages.find(x => x.locale === i18n.locale) || {}

  config.params = {...config.params, locale: currentLang.backendLocale}
  return config
}, error => {
  // Do something with request error
  return Promise.reject(error)
})

/**
 * The following solve the issue of Remote Password Reset Logic
 * AT AC, there is an API to reset QUATS login account password done by Admin which
 * means the user needed to be logged out on all sessions
 *
 * This implementation requires AC to reset all sessions of the user along with the
 * remember token. To make sure UI show correct logic, global axios middleware is placed to
 * clear store user, and force page reload so that the application
 * can be kicked in to normal flow as if the user is new to browser
 */
// window.axios.interceptors.response.use((res) => {
//   return res
// }, (error) => {
//   if(error && error.response && error.response.status) {
//     const code = error.response.status
//     const path = error.response && error.response.config && error.response.config.url ? error.response.config.url : ''
//     if(code === 401 && !path.includes('auth/login')) {
//       store.commit('account/user', null)
//       window.location.reload(true)
//     }
//   }
//
//   return Promise.reject(error)
// })
window.axios.interceptors.response.use((res) => {
  store.commit('interception/connectionError', false)
  if(res.data.error) {
    return Promise.reject(res)
  }
  return res
}, (error) => {
  if(!error.response) {
    store.commit('interception/connectionError', true)
    return Promise.reject(error)
  } else {
    store.commit('interception/connectionError', false)
    const code = error.response.status
    switch (code) {
    case 401:
      // cookie no longer valid, should log user out
      // the following will clear user, and trigger the reload function
      // to let server handle the auth from here
      store.commit('account/user', null)
      break
    case 403:
      store.commit('interception/authorizationError', true)
      break
    default:
      if (code >= 500) {
        store.commit('interception/serverError', true)
      }
    }
    return Promise.reject(error)
  }
})
